// extracted by mini-css-extract-plugin
module.exports = {"container":"Results_container__f0HJV","list":"Results_list__SCx5L","fallbackText":"Results_fallbackText__0_hQP"};